__turbopack_context__.v({
  "btcWarContainer": "CollectionGame-module__d9PcJG__btcWarContainer",
  "btcWarIframe": "CollectionGame-module__d9PcJG__btcWarIframe",
  "container": "CollectionGame-module__d9PcJG__container",
  "iframe": "CollectionGame-module__d9PcJG__iframe",
  "rocketIcon": "CollectionGame-module__d9PcJG__rocketIcon",
});
